import { useState } from "react";
import { useEffect } from "react";
import CreatePageStepOne from "./CreatePageStepOne";
import PageSetup from "./PageSetup";
import { pageServices } from "../../../APIServices/SitePilotManagement/pageServices";
import { FaBehance, FaDiscord, FaDribbble, FaFacebook, FaFacebookMessenger, FaFigma, FaGithub, FaGitlab, FaInstagram, FaLine, FaLinkedin, FaPinterest, FaQuora, FaReddit, FaShopify, FaSkype, FaSlack, FaSnapchat, FaSoundcloud, FaSpotify, FaStackOverflow, FaTelegram, FaThreads, FaTumblr, FaTwitter, FaViber, FaWeixin, FaWhatsapp, FaWordpress, FaXTwitter, FaYoutube } from "react-icons/fa6";

function PageData({getCurrectLoginUser}) {
  const [dataAvailable, setDataAvailable] = useState(false)
  const [themeColor, setThemeColor] = useState("#007bff")
  const [pageLogo, setPageLogo] = useState("")
  const [pageName, setPageName] = useState("")
  const [pageIdentifier, setPageIdentifier] = useState("")
  const [tabsManage, setTabsManage] = useState([])
  const [blogMenu, setBlogMenu] = useState(false)
  const [storeMenu, setStoreMenu] = useState(false)
  
  const [heroBadgeTitle, setHeroBadgeTitle] = useState("")
  const [heroHeading, setHeroHeading] = useState("")
  const [heroDescription, setHeroDescription] = useState("")
  const [heroHighLightedKey, setHeroHighLightedKey] = useState([])
  const [viewServicesButton, setViewServicesButton] = useState(false)
  
  const [aboutSection, setAboutSection] = useState(false)
  const [aboutTitle, setAboutTitle] = useState("")
  const [about, setAbout] = useState("")
  
  const [customDataSection, setCustomDataSection] = useState(false)
  const [customDataSectionTitle, setCustomDataSectionTitle] = useState("")
  const [customDataSectionSubTitle, setCustomDataSectionSubTitle] = useState("")
  const [customData, setCustomData] = useState([])
  
  const [expertiseSection, setExpertiseSection] = useState(false)
  const [expertiseSectionTitle, setExpertiseSectionTitle] = useState("")
  const [expertiseSectionSubTitle, setExpertiseSectionSubTitle] = useState("")
  const [expertise, setExpertise] = useState([])
  
  const [servicesSection, setServicesSection] = useState(false)
  const [servicesSectionTitle, setServicesSectionTitle] = useState("")
  const [servicesSectionSubTitle, setServicesSectionSubTitle] = useState("")
  const [services, setServices] = useState([])
  
  const [footerSection, setFooterSection] = useState(false)
  const [widgetFloatingIcon, setWidgetFloatingIcon] = useState("left")
  const [footerAdditionalText, setFooterAdditionalText] = useState("")
  const [socialLinks, setSocialLinks] = useState([])
  
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  
  const getPageDetails = async () => {
    setLoader(true)
    let data = await pageServices.getPageDetails()
    setDataAvailable(!!data?.data)

    setThemeColor(data?.data?.pageSettings?.headerSection?.themeColor || "#007bff")
    setPageLogo(data?.data?.pageSettings?.headerSection?.pageLogo || "")
    setPageName(data?.data?.pageSettings?.headerSection?.pageName || "")
    setBlogMenu(data?.data?.pageSettings?.headerSection?.blogMenu || false)
    setStoreMenu(data?.data?.pageSettings?.headerSection?.storeMenu || false)
    setPageIdentifier(data?.data?.pageSettings?.headerSection?.pageIdentifier || "")
    if ((data?.data?.pageSettings?.headerSection?.tabsManage || [])?.length > 0) {
      setTabsManage(data?.data?.pageSettings?.headerSection?.tabsManage)
    } else {
      setTabsManage([
        { isShow: data?.data?.pageSettings?.aboutSection?.aboutSection || false, id: "about", name: data?.data?.pageSettings?.aboutSection?.aboutTitle || "About" },
        { isShow: data?.data?.pageSettings?.customDataSection?.customDataSection || false, id: "custom", name: data?.data?.pageSettings?.customDataSection?.customDataSectionTitle || "Custom" },
        { isShow: data?.data?.pageSettings?.expertiseSection?.expertiseSection || false, id: "expertise", name: data?.data?.pageSettings?.expertiseSection?.expertiseSectionTitle || "Expertise" },
        { isShow: data?.data?.pageSettings?.servicesSection?.servicesSection || false, id: "services", name: data?.data?.pageSettings?.servicesSection?.servicesSectionTitle || "Services" },
        { isShow: data?.data?.pageSettings?.headerSection?.blogMenu || false, id: "blog", name: "Blog" },
        { isShow: data?.data?.pageSettings?.headerSection?.storeMenu || false, id: "store", name: "Store" },
      ]);
    }

    setHeroBadgeTitle(data?.data?.pageSettings?.heroSection?.heroBadgeTitle || "")
    setHeroHeading(data?.data?.pageSettings?.heroSection?.heroHeading || "")
    setHeroDescription(data?.data?.pageSettings?.heroSection?.heroDescription || "")
    setHeroHighLightedKey(data?.data?.pageSettings?.heroSection?.heroHighLightedKey || [])
    setViewServicesButton(data?.data?.pageSettings?.heroSection?.viewServicesButton || false)

    setAboutSection(data?.data?.pageSettings?.aboutSection?.aboutSection || false)
    setAboutTitle(data?.data?.pageSettings?.aboutSection?.aboutTitle || "About")
    setAbout(data?.data?.pageSettings?.aboutSection?.about || "")

    setCustomDataSection(data?.data?.pageSettings?.customDataSection?.customDataSection || false)
    setCustomDataSectionTitle(data?.data?.pageSettings?.customDataSection?.customDataSectionTitle || "Custom")
    setCustomDataSectionSubTitle(data?.data?.pageSettings?.customDataSection?.customDataSectionSubTitle || "")
    setCustomData(data?.data?.pageSettings?.customDataSection?.customData || [])

    setExpertiseSection(data?.data?.pageSettings?.expertiseSection?.expertiseSection || false)
    setExpertiseSectionTitle(data?.data?.pageSettings?.expertiseSection?.expertiseSectionTitle || "Expertise")
    setExpertiseSectionSubTitle(data?.data?.pageSettings?.expertiseSection?.expertiseSectionSubTitle || "")
    setExpertise(data?.data?.pageSettings?.expertiseSection?.expertise || [])

    setServicesSection(data?.data?.pageSettings?.servicesSection?.servicesSection || false)
    setServicesSectionTitle(data?.data?.pageSettings?.servicesSection?.servicesSectionTitle || "Services")
    setServicesSectionSubTitle(data?.data?.pageSettings?.servicesSection?.servicesSectionSubTitle || "")
    setServices(data?.data?.pageSettings?.servicesSection?.services || [])

    setFooterSection(data?.data?.pageSettings?.footerSection?.footerSection || false)
    setFooterAdditionalText(data?.data?.pageSettings?.footerSection?.footerAdditionalText || "")
    setSocialLinks(data?.data?.pageSettings?.footerSection?.socialLinks || [])
    setWidgetFloatingIcon(data?.data?.pageSettings?.footerSection?.widgetFloatingIcon || "left")

    setLoader(false)
  }

  const addUpdatePage = async () => {
    setSaveLoader(true);
    let pageSettings = {};
    pageSettings.headerSection = {
      pageLogo,
      pageName,
      themeColor,
      pageIdentifier,
      tabsManage,
      blogMenu,
      storeMenu
    };
    pageSettings.heroSection = {
      heroBadgeTitle,
      heroHeading,
      heroDescription,
      heroHighLightedKey,
      viewServicesButton,
    };
    pageSettings.aboutSection = {
      aboutSection,
      aboutTitle,
      about,
    };
    pageSettings.customDataSection = {
      customDataSection,
      customDataSectionTitle,
      customDataSectionSubTitle,
      customData,
    };
    pageSettings.expertiseSection = {
      expertiseSection,
      expertiseSectionTitle,
      expertiseSectionSubTitle,
      expertise,
    };
    pageSettings.servicesSection = {
      servicesSection,
      servicesSectionTitle,
      servicesSectionSubTitle,
      services,
    };
    pageSettings.footerSection = {
      footerSection,
      widgetFloatingIcon,
      footerAdditionalText,
      socialLinks
    };
    let data = await pageServices.addUpdatePage({ pageSettings });
    if (data?.statusCode === 200) {
      getPageDetails();
      getCurrectLoginUser()
    }
    setSaveLoader(false);
  };

  const handleInputChange = (setter) => (e) => {
    const value =
      e.target.type === "checkbox"
        ? e.target.checked
        : e.target.value;

    setter(value);
  };

  const addSocialRow = () => {
    setSocialLinks([...socialLinks, { icon: "", color: "", title: "", url: "" }]);
  };

  const removeSocialRow = (index) => {
    const updated = [...socialLinks];
    updated.splice(index, 1);
    setSocialLinks(updated);
  };

  const handleSocialChange = (index, field, value) => {
    const updated = [...socialLinks];
    updated[index][field] = value;
    setSocialLinks(updated);
  };

  const hasEmptySocialLinks = () => {
    if (
      socialLinks?.length === 1 &&
      !socialLinks[0]?.icon &&
      !socialLinks[0]?.color &&
      !socialLinks[0]?.title &&
      !socialLinks[0]?.url
    ) {
      return false;
    }
    return socialLinks?.some(
      (item) =>
        !item.icon?.trim() || !item.title?.trim() || !item.url?.trim()
    );
  };

  const ICON_MAP = {
    Whatsapp: FaWhatsapp,
    Instagram: FaInstagram,
    Facebook: FaFacebook,
    Messenger: FaFacebookMessenger,
    Linkedin: FaLinkedin,
    Twitter: FaTwitter,
    X: FaXTwitter,
    Youtube: FaYoutube,
    Snapchat: FaSnapchat,
    Telegram: FaTelegram,
    Pinterest: FaPinterest,
    Reddit: FaReddit,
    Discord: FaDiscord,
    Slack: FaSlack,
    Tumblr: FaTumblr,
    Viber: FaViber,
    Wechat: FaWeixin,
    Line: FaLine,
    Skype: FaSkype,
    Quora: FaQuora,
    Threads: FaThreads,
    Github: FaGithub,
    Gitlab: FaGitlab,
    Stackoverflow: FaStackOverflow,
    Dribbble: FaDribbble,
    Behance: FaBehance,
    Figma: FaFigma,
    Spotify: FaSpotify,
    Soundcloud: FaSoundcloud,
    Wordpress: FaWordpress,
    Shopify: FaShopify,
  };

  useEffect(() => {
    getPageDetails()
  }, []);
  return (
    <div className="bg-light d-flex align-items-center overflow-auto">
      {dataAvailable ?
        <PageSetup
          addUpdatePage={addUpdatePage}
          saveLoader={saveLoader}
          pageLogo={pageLogo}
          setPageLogo={setPageLogo}
          pageName={pageName}
          setPageName={setPageName}
          pageIdentifier={pageIdentifier}
          setPageIdentifier={setPageIdentifier}
          tabsManage={tabsManage}
          setTabsManage={setTabsManage}
          blogMenu={blogMenu}
          setBlogMenu={setBlogMenu}
          storeMenu={storeMenu}
          setStoreMenu={setStoreMenu}
          heroBadgeTitle={heroBadgeTitle}
          setHeroBadgeTitle={setHeroBadgeTitle}
          heroHeading={heroHeading}
          setHeroHeading={setHeroHeading}
          heroDescription={heroDescription}
          setHeroDescription={setHeroDescription}
          heroHighLightedKey={heroHighLightedKey}
          setHeroHighLightedKey={setHeroHighLightedKey}
          viewServicesButton={viewServicesButton}
          setViewServicesButton={setViewServicesButton}
          aboutSection={aboutSection}
          setAboutSection={setAboutSection}
          aboutTitle={aboutTitle}
          setAboutTitle={setAboutTitle}
          about={about}
          setAbout={setAbout}
          customDataSection={customDataSection}
          setCustomDataSection={setCustomDataSection}
          customDataSectionTitle={customDataSectionTitle}
          setCustomDataSectionTitle={setCustomDataSectionTitle}
          customDataSectionSubTitle={customDataSectionSubTitle}
          setCustomDataSectionSubTitle={setCustomDataSectionSubTitle}
          customData={customData}
          setCustomData={setCustomData}
          expertiseSection={expertiseSection}
          setExpertiseSection={setExpertiseSection}
          expertiseSectionTitle={expertiseSectionTitle}
          setExpertiseSectionTitle={setExpertiseSectionTitle}
          expertiseSectionSubTitle={expertiseSectionSubTitle}
          setExpertiseSectionSubTitle={setExpertiseSectionSubTitle}
          expertise={expertise}
          setExpertise={setExpertise}
          servicesSection={servicesSection}
          setServicesSection={setServicesSection}
          servicesSectionTitle={servicesSectionTitle}
          setServicesSectionTitle={setServicesSectionTitle}
          servicesSectionSubTitle={servicesSectionSubTitle}
          setServicesSectionSubTitle={setServicesSectionSubTitle}
          services={services}
          setServices={setServices}
          footerSection={footerSection}
          setFooterSection={setFooterSection}
          footerAdditionalText={footerAdditionalText}
          setFooterAdditionalText={setFooterAdditionalText}
          socialLinks={socialLinks}
          addSocialRow={addSocialRow}
          removeSocialRow={removeSocialRow}
          handleSocialChange={handleSocialChange}
          hasEmptySocialLinks={hasEmptySocialLinks}
          ICON_MAP={ICON_MAP}
          handleInputChange={handleInputChange}
          themeColor={themeColor}
          setThemeColor={setThemeColor}
          widgetFloatingIcon={widgetFloatingIcon}
          setWidgetFloatingIcon={setWidgetFloatingIcon}
        />
        :
        <CreatePageStepOne
          addUpdatePage={addUpdatePage}
          loader={loader}
          saveLoader={saveLoader}
          pageName={pageName}
          setPageName={setPageName}
          pageIdentifier={pageIdentifier}
          setPageIdentifier={setPageIdentifier}
          heroHeading={heroHeading}
          setHeroHeading={setHeroHeading}
          heroDescription={heroDescription}
          setHeroDescription={setHeroDescription}
          socialLinks={socialLinks}
          setSocialLinks={setSocialLinks}
          about={about}
          setAbout={setAbout}
          setAboutSection={setAboutSection}
          addSocialRow={addSocialRow}
          removeSocialRow={removeSocialRow}
          handleSocialChange={handleSocialChange}
          hasEmptySocialLinks={hasEmptySocialLinks}
          ICON_MAP={ICON_MAP}
          handleInputChange={handleInputChange}
        />
      }
    </div>
  );
}

export default PageData;